import type { Scorecard } from '../types/scorecard'

export function isDynamicScorecard(scorecard?: Scorecard) {
  if (!scorecard) return false
  return 'id' in scorecard && scorecard.id === null
}
